$(document).on('click', '.bn_menu-dropdown__button', function () {
    let that = $(this),
        container = that.parents('.bn_menu-dropdown'),
        menu = container.find('.bn_menu-dropdown__items-wrapper'),
        menuDom = menu.get(0);

    menu.removeClass('position-top');

    $('.bn_menu-dropdown__button').not(that).parents('.bn_menu-dropdown').removeClass('open');

    container.toggleClass('open')

    if (window.innerHeight - menuDom.getBoundingClientRect().bottom < 10) {
        menu.addClass('position-top')
    }

    $(document).on('click', '.auto-close', function () {
        $(this).parents('.bn_menu-dropdown').removeClass('open');
    });

    $(document).on('click', function (event) {
        if ($(event.target).closest('.bn_menu-dropdown__button, .bn_menu-dropdown__items-wrapper').length) return;

        $('.bn_menu-dropdown').removeClass('open');
    });
});